import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../axiosInstance";
import { apiEndPoints } from "../../api/apiEndpoints";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

export const fetchPrizeRulesData = createAsyncThunk(
  "fetchPrizeRulesData",
  (_, { rejectWithValue }) => {
    return Axios.get(
      `${apiEndPoints.prizeRules}`
    ).then((res) => res.data);
  }
);

export const prizeRulesSlice = createSlice({
  name: "prizeRules slice",
  initialState,
  reducers: {
    clearUtilsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // FETCH  UTILS API
    builder.addCase(fetchPrizeRulesData.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(fetchPrizeRulesData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchPrizeRulesData.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });
  },
});

// SELECTORS
export const selectPrizeRulesWhole = (store) => store?.prizeRules;
export const selectPrizeRulesLoader = (store) => store?.prizeRules?.isLoading;

// ACTIONS TO DISPATCH
export const { clearUtilsError } = prizeRulesSlice.actions;

export default prizeRulesSlice.reducer;
